//put this in the Site code
import wixLocation from 'wix-location';
import { session } from 'wix-storage'; //if you want  it to stay after the user has left use local instead of session

$w.onReady(function () {

let isValid = $w("#input1").valid;
let msg = $w("#input1").validationMessage;
$w("#input1").onCustomValidation( (value, reject) => {
  if(value === "evil") {
    reject("Please enter an email address with the format example@example.com");
  }
} );
 
 let path = wixLocation.path //not the full url just everything after the first /
 let sBreadtrail = session.getItem('breadtrail')
 if (sBreadtrail !== null) {
 let aBreadtrail = JSON.parse(sBreadtrail) //string to array
        aBreadtrail.push(path)
        sBreadtrail = JSON.stringify(aBreadtrail)
    } else {
        sBreadtrail = JSON.stringify([path])
    }
    session.setItem('breadtrail', sBreadtrail)
});